import { toolsMapInteraction } from './toolsMap-store'

let toolsMap;
toolsMapInteraction.subscribe(prop => {
    toolsMap = prop
})
export const getAllToolsMap=(id)=>{
    return toolsMap
}
export const getToolsMap=(id)=>{
    return toolsMap[0][id]
}
export const setToolsMap=(id,value)=>{
    toolsMapInteraction.update(prop => {
        prop[0][id]=value
        return prop
    })
    return toolsMap
}